import { useState } from "react";

export default function useToggler(time=200) {

  const [toggle, setToggle] = useState(false);

  const trigger = ()=> {
    setToggle(true);
    setTimeout(()=>  setToggle(false), time);
  }

  return [toggle, trigger];
}
